// extracted by mini-css-extract-plugin
export var codeBlock = "modern-module--codeBlock--264f1";
export var h1 = "modern-module--h1--345a0";
export var h2 = "modern-module--h2--ef91a";
export var h3 = "modern-module--h3--1ec76";
export var h4 = "modern-module--h4--296d3";
export var h5 = "modern-module--h5--12272";
export var h6 = "modern-module--h6--32ee8";
export var hAnchor = "modern-module--hAnchor--04f71";
export var linkAnchor = "modern-module--linkAnchor--40bcb";
export var list = "modern-module--list--64c68";
export var markdown = "modern-module--markdown--f855e";
export var para = "modern-module--para--3234e";
export var quote = "modern-module--quote--4501c";
export var tagAnchor = "modern-module--tagAnchor--6e862";